/* eslint-disable */
import axios from 'axios';
import { API2_HOST } from '../../helpers/urlHelper';
// const API2_HOST = `https://api2-dev.emplas.co.uk/v1`;

const otifCols = [
    // {
    //     accessor: 'CustCode',
    //     Header: 'Customer Code',
    //     isVisible: true
    // },
    {
        accessor: 'CustName',
        Header: 'Customer Name',
        isVisible: true
    },
    {
        accessor: 'Jobno',
        Header: 'Job No.',
        isVisible: true
    },
    {
        accessor: 'GlassID',
        Header: 'Glass ID',
        isVisible: true
    },
    {
        accessor: 'OrderDate',
        Header: 'Order Date',
        isVisible: true
    },
    {
        accessor: 'ScannedDate',
        Header: 'Scanned Date',
        isVisible: true
    },
    {
        accessor: 'RequiredDate',
        Header: 'Customer Required Date',
        isVisible: true
    },
    {
        accessor: 'GlassRequiredDate',
        Header: 'New Glass Required Date',
        isVisible: true
    },
    {
        accessor: 'GlassType',
        Header: 'Glass Type',
        isVisible: true
    },
    {
        accessor: 'IsOnTime',
        Header: 'On Time',
        isVisible: true
    },
];

const otifKeys = {
    actual: ['FivePlusDay', 'FiveDay', 'FourDay', 'ThreeDay', 'TwoDay', 'OneDay', 'SameDay', 'NotRecieved'],
    remake: ['RemakeFivePlusDay', 'RemakeFiveDay', 'RemakeFourDay', 'RemakeThreeDay', 'RemakeTwoDay', 'RemakeOneDay', 'RemakeSameDay', 'RemakeNotRecieved'],
    order: ['OrderFivePlusDay', 'OrderFiveDay', 'OrderFourDay', 'OrderThreeDay', 'OrderedOutOfLeadTime'],
};

const buildTotals = (data) => {
    return {
        actual: otifKeys.actual.reduce((sum, key) => sum + data[key].length, 0),
        remake: otifKeys.remake.reduce((sum, key) => sum + data[key].length, 0),
        order: otifKeys.order.reduce((sum, key) => sum + data[key].length, 0)
    };
};

const createDataset = (data, total, keys, isOnTime = true) => {
    // Regex splits the key by capital letters and adds a space before each
    return keys.map(key => ({
        name: `${key.replace(/([A-Z])/g, ' $1').trim()}`,
        value: calculatePercentages(data, total, key, isOnTime),
    }));
};

const calculatePercentages = (data, total, key, onTime = true) => {
    return data[key].filter(item => item.IsOnTime === onTime).length / total * 100;
};

const getTrans = (passData, failData) => {
    let transDataset = [0];
    let value = 0;
    for (let i = 1; i < Math.max(passData.length, failData.length); i++) {
        if (passData[i - 1]) value += passData[i - 1].value;
        if (failData[i - 1]) value += failData[i - 1].value;

        transDataset.push(value);
    }
    return transDataset;
};

const getPercentage = (data, total, prefix) => {
    return ((data[`${prefix}FivePlusDay`].filter(x => x.IsOnTime).length +
        data[`${prefix}FiveDay`].filter(x => x.IsOnTime).length +
        data[`${prefix}FourDay`].filter(x => x.IsOnTime).length +
        data[`${prefix}ThreeDay`].filter(x => x.IsOnTime).length +
        data[`${prefix}TwoDay`].filter(x => x.IsOnTime).length +
        data[`${prefix}OneDay`].filter(x => x.IsOnTime).length +
        data[`${prefix}SameDay`].filter(x => x.IsOnTime).length) / total) * 100;
};

const getJobNos = (data, keys) => [...new Set(keys.flatMap(x => data[x].map(y => y.Jobno)))];

const getOTIF = async (filters, signal) => {
    try {
        const res = await axios.get(`${API2_HOST}/glass-management/otif?start=${filters.start}&end=${filters.end}&supplier=${filters.supplier}`, {
            signal
        });
        if (res.status !== 200)
            throw new Error(`Failed to fetch OTIF data - Status code: ${res.status}`);

        if (res?.data) {
            const data = res.data;
            const totals = buildTotals(data);

            const datasets = {
                actual: {
                    pass: createDataset(data, totals.actual, otifKeys.actual),
                    fail: createDataset(data, totals.actual, otifKeys.actual, false),
                    trans: [],
                    percent: getPercentage(data, totals.actual, ''),
                    jobs: getJobNos(data, otifKeys.actual)
                },
                remake: {
                    pass: createDataset(data, totals.remake, otifKeys.remake),
                    fail: createDataset(data, totals.remake, otifKeys.remake, false),
                    trans: [],
                    percent: getPercentage(data, totals.remake, 'Remake'),
                    jobs: getJobNos(data, otifKeys.remake)
                },
                order: {
                    pass: createDataset(data, totals.order, otifKeys.order),
                    fail: createDataset(data, totals.order, otifKeys.order, false),
                    trans: [],
                    percent: 100 - ((data['OrderedOutOfLeadTime'].length / totals.order) * 100), // getPercentage(data, totals.order, 'Order'),
                }
            };

            datasets.actual.trans = getTrans(datasets.actual.pass, datasets.actual.fail);
            datasets.remake.trans = getTrans(datasets.remake.pass, datasets.remake.fail);
            datasets.order.trans = getTrans(datasets.order.pass, datasets.order.fail);
            return {
                totals,
                datasets,
                raw: data
            };
        }
        return null;
    }
    catch (error) {
        console.error('Error fetching OTIF data:', error);
        throw error;
    }
};

const getRechargeValue = async (target, percent, jobs) => {
    try {
        if (target > 0 && percent > 0 && jobs?.length > 0) {
            const res = await axios({
                method: 'POST',
                url: `${API2_HOST}/glass-management/otif-recharge`,
                data: { target, percent, jobs }
            });
            if (res.status !== 200)
                throw new Error(`Failed to fetch OTIF data - Status code: ${res.status}`);

            if (res?.data)
                return res.data;
        }
        return 0;
    } catch (error) {
        console.error('Error fetching OTIF data:', error);
        throw error;
    }
}

export {
    getOTIF,
    getRechargeValue,
    otifCols,
    otifKeys
};